import * as React from 'react';
import * as styles from './Breadcrumbs.css';
import { clsx } from 'clsx';

export const Breadcrumbs: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={clsx(styles['container'])}>{children}</div>;
};
